import React from 'react';

export function useToggle (initialState?: boolean) {
    const [value, setValue] = React.useState(initialState === true);

    const tick = React.useCallback(() => { setValue(s => !s) }, []);
    const handleTick = React.useCallback(() => tick(), [tick]);

    return React.useMemo(() => ({
        tick, value, handleTick
    }), [tick, value, handleTick]);
}